<template>
  <div>
    <mdb-modal size="lg" :show="visible" @shown="componentDidMount" @close="hideModal">
        <mdb-modal-header>
            <mdb-modal-title>{{this.merchant?this.merchant.name:""}}</mdb-modal-title>
        </mdb-modal-header>
        <mdb-modal-body>
                <mdb-row v-if="loading">
                    <mdb-col col="12" class="d-flex flex-center">
                        <mdb-spinner />
                    </mdb-col>
                </mdb-row>
                <mdb-container v-if="this.merchant">
                    <mdb-row>
                        <mdb-col col="12">
                            <div id="map" />
                            <img :src="require('@/assets/map_marker.png')" id="marker-center" />
                        </mdb-col>
                    </mdb-row>
                    <mdb-row>
                        <mdb-col col="12">
                            <mdb-input disabled v-model="merchant.address" label="Address" size="sm" />
                        </mdb-col>
                    </mdb-row>
                    <mdb-row>
                        <mdb-col col="4">
                            <mdb-input v-model="merchant.lat" label="Latittude *" size="sm" />
                        </mdb-col>
                        <mdb-col col="4">
                            <mdb-input v-model="merchant.lng" label="Longitude *" size="sm" />
                        </mdb-col>
                        <mdb-col col="4" v-if="checkPermissions(78)" class="d-flex align-items-center justify-content-end">
                            <mdb-spinner v-if="action_loading" class="p-0 m-0" small color="blue"/>
                            <mdb-btn v-if="!action_loading" @click="submitGeolocation" color="primary" size="sm">
                                Save Changes
                            </mdb-btn>
                        </mdb-col>
                    </mdb-row>
                </mdb-container>
        </mdb-modal-body>
    </mdb-modal>
  </div>
</template>

<script>
  import { mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbRow, mdbCol,
  mdbContainer, mdbSpinner, mdbInput, mdbBtn } from 'mdbvue';
  import {ajax} from '../js/ajax';
import { validateAllNumber } from '../js/validation';
import { checkPermissionsBinary } from '../js/helper';

  export default {
    components: {
        mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbRow, mdbCol,
        mdbContainer, mdbSpinner, mdbInput, mdbBtn
    },
    props: ['visible', 'close', 'focus_merchant'],
    data: ()=>({
        map: null,
        action_loading: false,
        merchant: null,
        loading:true,
    }),
    methods: {
        componentDidMount(){
            this.merchant=this.focus_merchant;  
            this.loading=false;
            this.username_disabled=true;
            setTimeout(()=>{
                this.renderMap();
            }, 800)
        },
        hideModal(){
            this.loading=true;
            this.map=null;
            this.merchant=null;
            this.action_loading=false;
            this.close();
        },
        renderMap(){
            const google = window.google;
            if(!this.map){
                var mapProp = {
                    center:new google.maps.LatLng(this.merchant.lat,this.merchant.lng),
                    zoom:16,
                };
                this.map=new google.maps.Map(document.getElementById("map"),mapProp);
                google.maps.event.addListener(this.map, 'dragend', ()=>{
                    this.merchant.lat=parseFloat(this.map.getCenter().lat()).toFixed(6);
                    this.merchant.lng=parseFloat(this.map.getCenter().lng()).toFixed(6);
                });
            }
        },
        submitGeolocation(){
            if(!validateAllNumber(this.merchant.lat) && !validateAllNumber(this.merchant.lng)){
                this.$notify.error({message: 'Invalid Lat and Lng Value', position:'top right', timeOut: 5000});
                return false;
            }
            this.action_loading=true;
            ajax({
                url: "admin/update_merchant_geolocation",
                data: {...this.merchant},
                complete: ()=>this.action_loading=false,
                success: ()=>{
                    this.$notify.success({message: this.merchant.name+' has been updated.', position:'top right', timeOut: 5000});
                },
            }, this)
        },
        checkPermissions(permission){
            return checkPermissionsBinary(permission, this.$store.state.permissions);
        },
    },
    watch: {
        merchant: {
            handler(val){
                const google = window.google;
                this.map.setCenter(new google.maps.LatLng(val.lat, val.lng));
            },
            deep: true
        }
    },
  };
</script>

<style scoped>
#map{
    height: 50vh;
    width: 100%;
}
#marker-center{
    position: absolute;
    top: 50%;
    left: 50%;
    height: 30px;
    width: 30px;
    margin-left:-15px;
    margin-top:-30px;
    z-index: 1000;
}
</style>